
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Journey from './pages/Journey';
import Navbar from "./components/Navbar";

import Footer from './components/Footer';
import './App.css';


function App() {
  return (
    <Router>
      <div className="app">
    <Navbar />
        <div className="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/journey" element={<Journey />} />
        </Routes>
     </div>
      <Footer />
   </div>
    </Router>
    
  );
}

export default App;


